import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";

export const GAME_BOOKING_CODE_QUERY_KEY = (gameId: number) => ['game', gameId, 'booking-code'];

type BookingCodeResponse = { bookingCode: string | null };

export const useGetGameBookingCode = (gameId: number) => {
    const apiClient = useApiClient();

    return useQuery<BookingCodeResponse>({
        queryKey: GAME_BOOKING_CODE_QUERY_KEY(gameId),
        queryFn: async () => {
            return apiClient.fetchApi<BookingCodeResponse, {}>({
                method: 'GET',
                endpoint: `games/${gameId}/admin-booking-code`
            });
        },
        enabled: !!gameId,
    });
};
